import { Box } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import IconContainer from './IconContainer'
import IconLabel from './IconLabel'

const CompletedIcon = ({ label }) => {
    return (
        <Box display="flex" alignItems="center">
            <IconContainer bgcolor="#307fc1">
                <Icon name="Stop" color="#ffffff" />
            </IconContainer>
            <IconLabel style={{ color: '#307fc1' }}>{label}</IconLabel>
        </Box>
    )
}

export default CompletedIcon
